import useSWR from 'swr';
import { fetchAuthSession } from 'aws-amplify/auth';

const fetchAuthSessionData = async () => {
  const authSession = await fetchAuthSession({});
  if (authSession.tokens) {
    return { isAuthenticated: true, tokens: authSession.tokens };
  }
  return { isAuthenticated: false, tokens: null };
};

const useAuthToken = () => {
 
  const { data, error, isLoading } = useSWR('authSession', fetchAuthSessionData, {
    revalidateOnFocus: true,
    shouldRetryOnError: true
  });

  return {
    isLoading,
    isAuthenticated: data?.isAuthenticated ?? null,
    error: error ? 'Failed to fetch authentication session.' : null
  };

};

export default useAuthToken;
